'use client';

import React, { type ReactElement } from 'react';

import { useMainLogic } from '@/features/collection-detail/hooks';
import classNames from 'classnames';
import { isDesktop } from 'react-device-detect';

import Footer from '@/common/components/footer';
import Layout from '@/common/components/layout/layout.component';
import Skeleton from '@/common/components/skeleton';
import { VendorShareContext } from '@/common/contexts/vendor-share.context';

import Body from './body.component';
import CollectionInfo from './collectionInfo.component';
import Header from './header.component';

const mainColor = 'text-white z-50';

export default function Main(): ReactElement {
  const {
    categoryListData,
    filteredData,
    payload,
    payloadSetter,
    openSearchBox,
    searchBarHandler,
    searchBoxCloseHandler,
    searchHandler,
    collection,
    vendorSlug,
    isLoading,
    collectionId,
    vendorInfo,
  } = useMainLogic();
  return (
    <VendorShareContext.Provider
      value={{
        vendorName: vendorSlug,
        vendorSlug,
        vendorSharable: true,
        isStore: true,
      }}
    >
      <Layout
        appbar={{
          showSearch: isDesktop,
          storeWidget: isDesktop,
          className: '!pt-0 lg:!pt-2',
          wrapperClassName: 'pt-3 !px-0 lg:!px-3',
          layoutChildrenClassNames: !isDesktop
            ? {
                storeWidgetBtnLinkClassName: mainColor,
                storeWidgetTitleClassName: mainColor,
                arrowClassName: mainColor,
                cartClassName: mainColor,
                hamburgerClassName: mainColor,
              }
            : undefined,
        }}
        responsiveAppbar={true}
        className={classNames(
          '!h-screen w-full overflow-auto lg:bg-silver-100',
          {
            'bg-silver-100': isLoading,
          }
        )}
      >
        {isLoading ? (
          <Skeleton
            type="home-slider"
            className="h-[200px] lg:hidden lg:min-h-[450px]"
          />
        ) : (
          <Header collection={collection} />
        )}
        <div className="mx-auto mb-4 h-auto w-full  md:w-[1168px]  ">
          {isLoading ? (
            <div className=" mt-4 lg:-mt-10">
              <Skeleton type="store-item-info" />
            </div>
          ) : (
            <CollectionInfo
              title={collection.title}
              categoryList={categoryListData}
              filteredData={filteredData}
              onSearch={searchHandler}
            />
          )}

          {isLoading ? (
            <>
              <div className="flex w-full gap-x-4 overflow-x-scroll px-4 lg:px-0 ">
                <Skeleton
                  type="filter-tag"
                  repeat={isDesktop ? 6 : 3}
                  className="rounded-lg  lg:w-24"
                />
              </div>

              <div className="mt-6 grid grid-cols-2 gap-x-4  gap-y-8 bg-silver-100 px-4 pb-4 lg:mt-12 lg:flex lg:flex-wrap lg:justify-between lg:gap-x-6 lg:px-0">
                <Skeleton type="product-item" repeat={10} />
              </div>
            </>
          ) : (
            <Body
              collectionId={collectionId}
              categoryListData={categoryListData}
              vendorInfo={vendorInfo?.data}
              filteredData={filteredData}
              openSearchBox={openSearchBox}
              payloadSetter={payloadSetter}
              payload={payload}
              searchBarHandler={searchBarHandler}
              searchBoxCloseHandler={searchBoxCloseHandler}
              searchHandler={searchHandler}
            />
          )}
        </div>

        <Footer />
      </Layout>
    </VendorShareContext.Provider>
  );
}
